import { useState } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CompanyExperience from './components/CompanyExperience';
import ValueProposition from './components/ValueProposition';
import Features from './components/Features';
import SocialProof from './components/SocialProof';
import HowItWorks from './components/HowItWorks';
import ProductGallery from './components/ProductGallery';
import Pricing from './components/Pricing';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ContactModal from './components/ContactModal';
import SeoHead from './components/SeoHead';

export default function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead />
      <Navbar onContact={openModal} />
      <HeroSection onContact={openModal} />
      <CompanyExperience />
      <ValueProposition />
      <ProductGallery />
      <SocialProof />
      <HowItWorks />
      <Features />
      <Pricing onContact={openModal} />
      <FinalCTA onContact={openModal} />
      <Footer onContact={openModal} />
      <ContactModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}